import React from "react";

export function SpinnyThingy(): React.ReactElement {
  const squares = [
    {x: 60, y: 60},
    {x: 130, y: 60},
    {x: 200, y: 60},
    {x: 200, y: 130},
    {x: 200, y: 200},
    {x: 130, y: 200},
    {x: 60, y: 200},
    {x: 60, y: 130},
  ]

  return <div style={{width: "100%", textAlign: "center"}}>
    <svg viewBox="0 0 320 320" style={{maxWidth:"320px"}}>
      {squares.map((square, index) =>
        <rect
          key={index}
          {...square}
          width={60}
          height={60}
          rx={4}
          transform-origin={`${square.x + 30} ${square.y + 30}`}
        >
          <animate
            attributeName="fill"
            values="#333333;#87d137;#333333;#333333"
            keyTimes="0;0.1;0.4;1"
            dur="2s"
            repeatCount="indefinite"
            begin={`${index/4}s`}
          />
          <animateTransform
            attributeName="transform"
            type="scale"
            values="1;1.1;1;1"
            keyTimes="0;0.1;0.4;1"
            dur="2s"
            repeatCount="indefinite"
            begin={`${index/4}s`}
          />
        </rect>
      )}
    </svg>
  </div>
}
